
const COLOURS = {
  trace: 'lightblue',
  info: 'blue',
  warn: 'pink',
  error: 'red',
}; // choose better colours :)

class Log {
  generateMessage(level, message) {

    const color = COLOURS[level];

    //if (process.env.NODE_ENV === 'development') {
    console.log(...message);
    console.log(`%c${message}`, `color:${color}`);
    // }
  }

  trace(message) {
    return this.generateMessage('trace', message);
  }

  info(message) {
    return this.generateMessage('info', message);
  }

  warn(message) {
    return this.generateMessage('warn', message);
  }

  error(message) {
    return this.generateMessage('error', message);
  }
}

export default new Log();
